import { render, staticRenderFns } from "./OrganizationIcon.vue?vue&type=template&id=a3c3e336&scoped=true&"
import script from "./OrganizationIcon.vue?vue&type=script&lang=js&"
export * from "./OrganizationIcon.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationIcon.vue?vue&type=style&index=0&id=a3c3e336&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3e336",
  null
  
)

export default component.exports